import { render, staticRenderFns } from "./WelcomeBoard.vue?vue&type=template&id=2f692fae&"
import script from "./WelcomeBoard.vue?vue&type=script&lang=ts&"
export * from "./WelcomeBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WelcomeBoard.vue"
export default component.exports